import { gql } from '@apollo/client';

export const deleteOperator = gql`
  mutation DeleteOperator($input: OperatorDeleteInput!) {
    deleteOperator(input: $input)
  }
`;

export const updateOperator = gql`
  mutation UpdateOperator($input: OperatorUpdateInput!) {
    updateOperator(input: $input) {
      id
      name
      email
      role
      language
      isPhoneNotified
      isEmailNotified
      isResourceStatus
      isBatteryDeepDischarge
      isCleaningTaskStopped
      isCleaningTaskFinished
      isEmergencyStop
      isErrorOccurred
      isServiceNeeded
      isLocationStatus
    }
  }
`;

export const createOperator = gql`
  mutation CreateOperator($input: OperatorCreateInput!) {
    createOperator(input: $input) {
      name
      email
      role
      language
      isPhoneNotified
      isEmailNotified
      isResourceStatus
      isBatteryDeepDischarge
      isCleaningTaskStopped
      isCleaningTaskFinished
      isEmergencyStop
      isErrorOccurred
      isServiceNeeded
      isLocationStatus
      machine {
        alias
      }
    }
  }
`;
